import { keepPreviousData, skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from 'src/api/rpc/client';

/**
 * Hook to fetch an email thread by conversation ID
 */
export function useEmailThread(conversationId: string | null) {
  return useQuery({
    ...orpc.communications.emailThreads.getThread.queryOptions({
      input: conversationId
        ? {
            conversationId,
          }
        : skipToken,
    }),
    placeholderData: keepPreviousData,
  });
}
